import Request from '~/providers/Request';

export const fetchHolders = async (input, page, resolve) => {
  await Request.get('/admin/holders', {
    sorter: 'name.asc',
    qs: input,
    page: page,
    perPage: 15,
  }).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name || ''}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
